// extracted by mini-css-extract-plugin
export default {"wrapper":"menuDesk_wrapper__4M-xy","menuBox":"menuDesk_menuBox__XM797","menuBar":"menuDesk_menuBar__udhfr","wishBtn":"menuDesk_wishBtn__zGMCZ"};